import { render, staticRenderFns } from "./asinQuery.vue?vue&type=template&id=ef42ace4&scoped=true"
import script from "./asinQuery.vue?vue&type=script&lang=js"
export * from "./asinQuery.vue?vue&type=script&lang=js"
import style0 from "./asinQuery.vue?vue&type=style&index=0&id=ef42ace4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef42ace4",
  null
  
)

export default component.exports